import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleMaintainanceWrapper = styled.div`
  border: 1px solid ${({ theme }: any) => theme.colors.borderColor};
  border-radius: 16px;
  background-color: ${({ theme }: any) => theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* Removed static boxShadow */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
`

export const StyleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 12px;
  flex: 0.8;
`

export const StyleTitle = styled.p`
  color: ${({ theme }: any) => theme.colors.text};
  font-size: 18px;
  font-weight: 400;
`
export const Stylesubtitle = styled.p`
  color: ${({ theme }: any) => theme.colors.text50};
  font-size: 14px;
  line-height: 1.5;
`
